import React from "react";
import { motion } from "framer-motion";

const MedicationReminderGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div>
                <h4 className="font-medium text-[#002B5C] mb-1">برنامه دارویی امروز</h4>
                <div className="space-y-2">
                    <div className="flex items-center justify-between p-2 bg-[#ECEFF1] rounded-[16px] shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="flex items-center">
                            <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                            <span className="text-sm">آتورواستاتین ۲۰ میلی‌گرم</span>
                        </div>
                        <span className="text-xs text-green-500">✓ مصرف شده (صبح)</span>
                    </div>
                    <div className="flex items-center justify-between p-2 bg-[#ECEFF1] rounded-[16px] shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="flex items-center">
                            <div className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                            <span className="text-sm">متفورمین ۵۰۰ میلی‌گرم</span>
                        </div>
                        <span className="text-xs text-[#9EA3A9]">۱۸:۰۰ (بعد از شام)</span>
                    </div>
                    <div className="flex items-center justify-between p-2 bg-[#ECEFF1] rounded-[16px] shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="flex items-center">
                            <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                            <span className="text-sm">لوزارتان ۵۰ میلی‌گرم</span>
                        </div>
                        <span className="text-xs text-[#9EA3A9]">۲۲:۰۰ (قبل از خواب)</span>
                    </div>
                </div>

                <h4 className="font-medium text-[#002B5C] mt-4 mb-1">پیشرفت امروز</h4>
                <div className="w-full bg-[#ECEFF1] rounded-full h-2 mb-2">
                    <motion.div className="bg-[#FF9500] h-2 rounded-full" initial={{ width: 0 }} animate={{ width: "33%" }} transition={{ duration: 0.2, ease: [0.4, 0.0, 0.2, 1] }} />
                </div>
                <div className="flex justify-between text-xs text-[#9EA3A9]">
                    <span>۱ از ۳ دوز</span>
                    <span>۳۳٪ تکمیل شده</span>
                </div>

                <div className="mt-4 p-3 bg-[#ECEFF1] rounded-[16px] shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    <h4 className="font-medium text-[#002B5C] mb-1">یادآوری‌ها</h4>
                    <div className="flex items-center space-x-2-reverse mb-1 flex-row-reverse">
                        <svg className="w-4 h-4 text-[#FF9500]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <span className="text-sm">۱۵ دقیقه قبل از زمان مصرف</span>
                    </div>
                    <div className="flex items-center space-x-2-reverse flex-row-reverse">
                        <svg className="w-4 h-4 text-[#FF9500]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                            ></path>
                        </svg>
                        <span className="text-sm">اعلان در صورت فراموشی</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MedicationReminderGraph;
